module.exports = __webpack_public_path__ + "img/crystal-gold-logo.0eb7a4a1.svg";